module.exports = __webpack_public_path__ + "img/arrowLeft.8f846d3c.svg";